import React from "react";
import styles from "./style.module.css";

import { Button } from "aible";

import { VIEW_TYPE } from "containers/View/reducer";
import { centerHex } from "containers/Next/NextReducer";

import AibleLogo from "images/Aible_Logo/Aible_Logo.png";
import pathFind from "images/tileIcons/walkthrough-dark.svg";
import Tour from "reactour";

export default class SenseTour extends React.Component {
  // Hack so enter continues instead of closing tour
  hiddenUpdateStep(timeout) {
    const { step, updateStep } = this.props;

    document.getElementById("continueButton") &&
      document.getElementById("continueButton").children[0] &&
      document.getElementById("continueButton").children[0].click();

    return updateStep(step + 1);
  }

  render() {
    const { isOpen, step, updateIsOpenExplore, updateStep, updateType, scrollReportByTitle } = this.props;

    const handleClickSection = (section) => {
      const clickableDiv = document.getElementById(section);

      if (clickableDiv) {
        clickableDiv.click();
      }
    };

    const setShowHighlight = (isShowHighlight) => {
      const highlightDiv = document.getElementById("mask-main");

      if (highlightDiv) {
        highlightDiv.style.display = isShowHighlight === true ? "block" : "none";
      }
    };

    const CLOSE_DELAY = 300;
    const OPEN_DELAY = 600;

    const listHolder = document.getElementById("hexListScroll");
    const isListMode = listHolder !== undefined && listHolder !== null;

    const firstChartId = isListMode ? "nextListChart_0" : "hexTile_8_7_0";

    const steps = [
      {
        selector: "#mainApp",
        content: ({ goTo, inDOM }) => (
          <div className={styles.tContent}>
            <div className={styles.aibleLogo}>
              <img src={AibleLogo} style={{ width: "100%", height: "auto" }} />
            </div>
            <div className={styles.tHeader + " " + styles.centered}>{"Welcome to Aible Explore!"}</div>
            <div>
              {"Understand business drivers, uncover root causes, and identify contextual insights in minutes."}
            </div>
            <div className={styles.logoWrapper}>
              <img
                src={pathFind}
                style={{
                  marginTop: "-2px",
                  width: "100%",
                  height: "auto"
                }}
              />
            </div>

            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateStep(step + 1);
                  scrollReportByTitle(0);
                  setShowHighlight(true);
                }}
              >
                {"Show Me Around"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#comboCount",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Automatically Find the Most Important Insights"}</div>
            <div>
              {
                "Aible evaluates every variable combination in your dataset (likely tens of thousands of combinations) and displays only the most relevant insights to your selected outcome."
              }
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#outcomeSuccessSelect",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Outcome Success Value"}</div>
            <div>{"You may choose to select a different success value for your outcome here."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#leakageSizer",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Circular Sankey"}</div>
            <div>
              {
                "Insights highlight the key drivers through the circular Sankey visualization, consisting of chords and arcs. The arcs show the relative importance of a variable, and the arcs show the significance of the interactions between two variables."
              }
            </div>
            <div style={{ marginTop: "20px" }}>
              {
                "Interactions highlight key behaviors that may influence your selected outcome. Exploring these interactions can often offer valuable insights about your business."
              }
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button
                type="primary"
                onClick={() => {
                  // document.getElementById(
                  // 	"reportChart_8_7_0"
                  // ) &&
                  // 	document
                  // 		.getElementById("reportChart_8_7_0")
                  // 		.scrollIntoView({
                  // 			behavior: "smooth",
                  // 		});

                  scrollReportByTitle(1);

                  updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#reportScroll",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"The Report"}</div>
            <div>
              {"All of the top insights related to your outcome are automatically added to the report on the left."}
            </div>
            <div style={{ marginTop: "20px" }}>
              {"Remove any insight you are uninterested in by clicking the unpin. Unpinning removes the insight from the report and the " +
                (isListMode ? "list view" : "hexagon map") +
                " on the right."}
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: isListMode ? "#hexListScroll" : "#hexGridSection",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>
              {isListMode ? "Top Insights List" : "Top Insights and the Hexagon Map"}
            </div>
            <div>
              {isListMode
                ? "This list shows the top insights related to the outcome. There are charts of the top variables that help explain the outcome. Beneath them shows the top insights involving the interaction of two variables with the outcome."
                : "This hex map shows the top insights related to the outcome. The first ring lists the top variables that help explain the outcome. The second ring of stacked insights shows the top insights involving the interaction of two variables with the outcome."}
            </div>
            {isListMode !== true && (
              <div style={{ marginTop: "20px" }}>
                {"The insight importance follows a clockwise pattern with the most important listed at the top."}
              </div>
            )}
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button
                type="primary"
                onClick={() => {
                  centerHex({ x: 8, y: 7 }, true);

                  setTimeout(() => {
                    updateStep(step + 1);
                  }, 1000);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#" + firstChartId,
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Exploring Insights"}</div>
            <div>{"Clicking on any insight will present additional insights related to your selected one."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button
                type="primary"
                onClick={() => {
                  handleClickSection(firstChartId);

                  centerHex({ x: 8, y: 7 }, true, true);

                  setTimeout(() => {
                    updateStep(step + 1);
                  }, 500);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: isListMode ? "#directionSection_0" : "#hexGridSection",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Exploring Insights (Continued)"}</div>
            <div>
              {"Click " +
                (isListMode ? "show all" : "") +
                " on any " +
                (isListMode ? "related list" : "full-color hexagon") +
                " to find more insights of that type. Each type of insight focuses on a specificific type of analysis:"}
            </div>
            <div style={{ marginTop: "20px" }}>
              <ul>
                <li>
                  {
                    "Drill-down on a variable: This is similar to a drill down graph. Aible focuses you on a subset of the overall data where this variable has a very different relationship with the outcome."
                  }
                </li>
                <li>
                  {
                    "Benchmark (group by) a specific variable: This is similar to a group-by or comparison analysis. Aible focuses you on situations where a specific value of the variable behaves differently from all other values of the variable."
                  }
                </li>
                <li>
                  {
                    "What is statistically related to a variable: This is similar to a statistical association analysis. Aible guides you to other variables that may be related to or exhibit behaviors similar to the chosen variable. "
                  }
                </li>
                <li>
                  {
                    "Importance according to different models: If a model training has been conducted on the data (requires Aible Optimize license) then this shows how different models consider the importance of each variable-value. If most of the models agree then the pattern is more reliable / actionable. However, if the models disagree with each other or your chosen model disagrees with the rest of the models, then you should act with caution in acting upon that pattern."
                  }
                </li>
              </ul>
            </div>
            <div className={styles.sFooter}>
              <Button
                onClick={() => {
                  handleClickSection("closeButton");
                  centerHex({ x: 8, y: 8 }, true, true);

                  setTimeout(() => {
                    updateStep(step - 1);
                  }, 500);
                }}
              >
                {"Previous"}
              </Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#nextSearch",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Searching Insights"}</div>
            <div>
              {
                "Quickly find any insight you are interested in by using the search bar. Results are presented in order of importance. So if you are interested in how a specific product or country behaves most differently (for example), you can search for it here and see an ordered list of the most actionable insights related to it."
              }
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#filterButton",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Filter Data"}</div>
            <div>{"Clicking the Filter Data button will allow you to filter the dataset."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#pinButton",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Pinning Charts"}</div>
            <div>
              {"Pin insights to save the chart to the report and add the " +
                (isListMode ? "insight" : "hexagon") +
                " to the " +
                (isListMode ? "list" : "map") +
                " view."}
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button
                type="primary"
                onClick={() => {
                  handleClickSection("closeButton");
                  centerHex({ x: 8, y: 8 }, true, true);

                  updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#tasksButton",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Tasks"}</div>
            <div>{"Add collaborators and get feedback by assigning insights to new users."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#nextFooter",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Next Timeline"}</div>
            <div>{"Completed and pending tasks will appear here on the timeline."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#saveButton",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Saving Exploration"}</div>
            <div>
              {
                "Save any exploration you create, and it will appear in the Projects tab on the home screen. Open any exploration on the Projects tab to continue exploring insights from where you saved."
              }
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#pptButton",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Downloading PPT"}</div>
            <div>
              {
                "Quickly share the insights you discover by downloading a PowerPoint presentation containing all the pinned charts."
              }
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#mainApp",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"You Are Ready to Start Exploring!"}</div>
            <div>
              <span>{"Please visit our online "}</span>
              <a href={"https://aible.zendesk.com/hc/en-us"}>{"help portal"}</a>
              <span>{" or reach out to your customer success partner if you have additional questions. "}</span>
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button
                type="primary"
                onClick={() => {
                  updateIsOpenExplore(false);
                }}
              >
                {"End Walkthrough"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      }
    ];

    return (
      <Tour
        steps={steps}
        isOpen={Boolean(isOpen)}
        onRequestClose={() => updateIsOpenExplore(false)}
        goToStep={step}
        startAt={step}
        showNavigation={false}
        showButtons={false}
        closeWithMask={false}
        disableInteraction={false}
        rounded={5}
        accentColor={"#512e77"}
        highlightedMaskClassName={"helpMePlease"}
      />
    );
  }
}
